var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploadFile"},[_c('upload-files',{attrs:{"phase":2}}),_c('img',{staticClass:"footer-upload",attrs:{"src":require("../assets/Intersection1.png")}}),(this.getLoadingUploadFileCdg)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }